import React from 'react';
import { useCart } from '../../../context/CartContext.jsx';
import { FaTrashAlt, FaMinus, FaPlus } from 'react-icons/fa';

const CartItem = ({ item }) => {
    const { updateQuantity, removeFromCart } = useCart();

    return (
        <div className="cart-item-modern-card mb-3 p-3 shadow-sm rounded-4 bg-white border-0 transition-hover">
            <div className="d-flex gap-3 align-items-center">
                {/* Product Image */}
                <div className="cart-item-image-box">
                    <img src={item.productImage} alt={item.title} className="cart-item-image rounded-3" />
                </div>

                <div className="cart-item-info-box flex-grow-1">
                    <div className="d-flex justify-content-between align-items-start mb-1">
                        <div>
                            <h6 className="item-name fw-bold mb-0 text-dark">{item.title}</h6>
                            <span className="item-variant text-muted">Size: {item.size}</span>
                        </div>
                        <button 
                            className="remove-item-btn" 
                            onClick={() => removeFromCart(item.id, item.size)}
                        >
                            <FaTrashAlt />
                        </button>
                    </div>

                    <div className="d-flex justify-content-between align-items-center mt-2 flex-wrap gap-2">
                        <div className="price-tag">
                            <span className="fw-bold fs-5 color_primary">{item.price} $</span>
                        </div>

                        <div className="cart-qty-pill d-flex align-items-center bg-light rounded-pill px-2 py-1">
                            <button 
                                className="qty-action-btn" 
                                onClick={() => updateQuantity(item.id, item.size, item.quantity - 1)}
                                disabled={item.quantity <= 1}
                            >
                                <FaMinus />
                            </button>
                            <span className="mx-3 qty-count fw-bold">{item.quantity}</span>
                            <button 
                                className="qty-action-btn" 
                                onClick={() => updateQuantity(item.id, item.size, item.quantity + 1)}
                            >
                                <FaPlus />
                            </button>
                        </div>
                    </div>
                    
                    <div className="mt-2 pt-2 border-top d-md-none text-end">
                        <span className="text-muted small">Subtotal: </span>
                        <span className="fw-bold color_primary">{(parseFloat(item.price) * item.quantity).toFixed(2)} $</span>
                    </div>
                </div>

                {/* Subtotal Desktop */}
                <div className="d-none d-md-flex flex-column align-items-end ms-4 border-start ps-4">
                    <p className="text-muted small mb-1">Subtotal</p>
                    <h5 className="fw-bold text-dark">{(parseFloat(item.price) * item.quantity).toFixed(2)} $</h5>
                </div>
            </div>
        </div>
    );
};

export default CartItem;
